/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_Cancel_BodyInputs */

const en_us2_workout_after_cancel_body = /** @type {(inputs: Workout_After_Cancel_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It doesn't count as done and the plan doesn't move on: the same workout stays today's, for when you can.`)
};

const pt_br2_workout_after_cancel_body = /** @type {(inputs: Workout_After_Cancel_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ele não conta como feito e o plano não avança: o mesmo treino continua sendo o de hoje, para quando você puder.`)
};

const es_419_workout_after_cancel_body = /** @type {(inputs: Workout_After_Cancel_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No cuenta como hecho y el plan no avanza: el mismo entrenamiento sigue siendo el de hoy, para cuando puedas.`)
};

const pt_pt2_workout_after_cancel_body = /** @type {(inputs: Workout_After_Cancel_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não conta como feito e o plano não avança: o mesmo treino continua a ser o de hoje, para quando puderes.`)
};

const fr_fr2_workout_after_cancel_body = /** @type {(inputs: Workout_After_Cancel_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elle ne compte pas comme faite et le programme n'avance pas : la même séance reste celle du jour, pour quand tu pourras.`)
};

const de_de2_workout_after_cancel_body = /** @type {(inputs: Workout_After_Cancel_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es zählt nicht als erledigt und der Plan geht nicht weiter: Dasselbe Training bleibt das heutige, für wann du kannst.`)
};

const it_it2_workout_after_cancel_body = /** @type {(inputs: Workout_After_Cancel_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non conta come fatto e la scheda non avanza: lo stesso allenamento resta quello di oggi, per quando puoi.`)
};

/**
* | output |
* | --- |
* | "It doesn't count as done and the plan doesn't move on: the same workout stays today's, for when you can." |
*
* @param {Workout_After_Cancel_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_cancel_body = /** @type {((inputs?: Workout_After_Cancel_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Cancel_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_cancel_body(inputs)
	if (locale === "es-419") return es_419_workout_after_cancel_body(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_cancel_body(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_cancel_body(inputs)
	if (locale === "de-DE") return de_de2_workout_after_cancel_body(inputs)
	if (locale === "it-IT") return it_it2_workout_after_cancel_body(inputs)
	return en_us2_workout_after_cancel_body(inputs)
});
export { workout_after_cancel_body as "workout-after.cancel_body" }